import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import smartOutline from 'smart-outline';
import 'typeface-roboto';

import * as serviceWorker from './serviceWorker';
import history from 'utils/history';
import { MESSAGES } from 'utils/i18n';

import store from './redux/store';
import Routes from './routes';

import './index.css';

smartOutline.init();

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider key={'en-GB'} locale={'en-GB'} messages={MESSAGES['en']}>
      <Provider store={store}>
        <BrowserRouter history={history}>
          <Route path="/" component={Routes} />
        </BrowserRouter>
      </Provider>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
